import { toArray as a } from "../../../../utils/helpers.js";
import { useControlledState as o } from "../../../../utils/hooks/useControlledState.js";
import { getFormControlValueAsString as u } from "../../../../utils/helpers.form.js";
const i = (r) => {
  const t = o(r);
  return {
    ...t,
    getLabelsArray: () => a(t.value).map((e) => e.label),
    getLabelsString: (e = ",") => a(t.value).map((l) => l.label).join(e),
    getValuesArray: () => a(t.value).map(
      (e) => u(e.value)
    ),
    getValuesString: () => a(t.value).map((e) => e.value).join(",")
  };
};
export {
  i as useRichSelectState
};
